// Shared POI name validation for the "create POI" dialog (mapWrapper.js) and the
// POI list's inline rename (poi.js). Mirrors the rules enforced server-side by
// WebPoiRequest.Name / WebPoiService in AltrackWebApi, so the user sees the same
// rejection before submitting instead of only after a round trip.

export const POI_NAME_MAX_LEN = 35;
// Only letters, numbers, spaces, and dashes — and at least one letter/number (not all spaces/dashes).
export const POI_NAME_PATTERN = /^(?=.*[A-Za-z0-9])[A-Za-z0-9 -]+$/;

/**
 * @param {string} name - candidate name (untrimmed is fine)
 * @param {Array<{id?: string, name?: string}>} existingPois - this account's other POIs
 * @param {string|null} [excludeId] - id of the POI being edited, excluded from the duplicate check
 * @returns {string|null} an error message, or null if the name is valid
 */
export function poiNameError(name, existingPois = [], excludeId = null) {
  const trimmed = (name || "").trim();
  if (!trimmed) return "POI name is required";
  if (trimmed.length > POI_NAME_MAX_LEN) return `POI name must be ${POI_NAME_MAX_LEN} characters or fewer`;
  if (!POI_NAME_PATTERN.test(trimmed)) return "Only letters, numbers, spaces, and dashes are allowed";

  const isDup = existingPois.some((p) =>
    p.id !== excludeId && (p.name || "").trim().toLowerCase() === trimmed.toLowerCase()
  );
  if (isDup) return "A POI with this name already exists";

  return null;
}
